export default function initInpageNav() {
  Alpine.data('inpageNav', () => ({
    isFixed: false,
    topOffset: 0,
    activeSection: '',
    isDragging: false,
    startX: 0,
    scrollLeft: 0,

    init() {
      this.$watch('isFixed', () => {this.$root.classList.toggle('nav-fixed')});
      this.$watch('activeSection', () => {
        const navItems = this.$el.querySelectorAll('nav a') as NodeListOf<HTMLAnchorElement>;
        navItems.forEach(item => {
          if (item.getAttribute('href') == `#${this.activeSection}`) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        })
      })

      const nav = this.$el.querySelector('nav') as HTMLElement;
      const navContainer = this.$el.querySelector('ul') as HTMLElement;
      const mainNav = document.getElementById('header');
      const mainNavInner = document.getElementById('header-inner');
      const navOffsetTop = nav.offsetTop;
      const sections = Array.from(this.$el.querySelectorAll('[id]'));
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.activeSection = entry.target.id;
            }
          });
        },
        { threshold: 0.5 }
      );

      sections.forEach((section) => observer.observe(section));

      const updateTopOffset = () => {
        this.topOffset = mainNav && mainNav.classList.contains('scroll-up') && mainNavInner ? mainNavInner.getBoundingClientRect().height : 0;
      }

      const isPartiallyInViewport = (element: HTMLElement) => {
        const rect = element.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      };

      updateTopOffset();
      window.addEventListener('resize', updateTopOffset);
      window.addEventListener('scroll', () => window.setTimeout(() => {
        updateTopOffset();

        if (isPartiallyInViewport(this.$root)) {
          this.isFixed = window.scrollY >= navOffsetTop - this.topOffset;
        } else {
          this.isFixed = false;
        }

        if (this.isFixed) {
          nav.style.top = `${this.topOffset}px`;
        } else {
          nav.style.top = '';
        }
      }, 300));

      navContainer.addEventListener('mousedown', (e) => {
        this.isDragging = true;
        this.startX = e.pageX - navContainer.offsetLeft;
        this.scrollLeft = navContainer.scrollLeft;
      });

      navContainer.addEventListener('mouseleave', () => {
        this.isDragging = false;
      });

      navContainer.addEventListener('mouseup', () => {
        this.isDragging = false;
      });

      navContainer.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.pageX - navContainer.offsetLeft;
        const walk = x - this.startX;
        navContainer.scrollLeft = this.scrollLeft - walk;
      });

      navContainer.addEventListener('touchstart', (e) => {
        this.isDragging = true;
        this.startX = e.touches[0].pageX - navContainer.offsetLeft;
        this.scrollLeft = navContainer.scrollLeft;
      });

      navContainer.addEventListener('touchend', () => {
        this.isDragging = false;
      });

      navContainer.addEventListener('touchmove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.touches[0].pageX - navContainer.offsetLeft;
        const walk = x - this.startX; // Adjust scroll speed
        navContainer.scrollLeft = this.scrollLeft - walk;
      });
    }
  }));
}
